export interface AscBreadcrumbItemProps {
  children: React.ReactNode;
  href?: string;
  className?: string;
  innerTextClassName?: string;
  loading?: boolean;
  onClick?: () => void;
}

export function AscBreadcrumbItem({ children }: AscBreadcrumbItemProps) {
  return <>{children}</>;
}
